export enum CACHE {
  REDIRECT_TO = 'redirectTo',
  AUTHENTICATION = 'authentication'
};
